import { useEffect } from 'react';
import { OfferProvider, SinglePaymentOffer, SubscriptionOffer, useOffersQuery } from 'api/graphql';
import { useDispatch, useSelector } from 'react-redux';
import Actions from 'Redux/Actions';
import { getEnteredCouponCode, getOffers } from 'Redux/Queries';

export const useGetOffers = () => {
  const dispatch = useDispatch();

  const enteredCouponCode = useSelector(getEnteredCouponCode);
  const offers = useSelector(getOffers);

  const { loading, data, error, refetch } = useOffersQuery({
    variables: {
      provider: OfferProvider.Stripe,
      couponCode: enteredCouponCode,
    },
  });

  useEffect(() => {
    if (!data) {
      return;
    }
    const zppPlan = data.offers.find((offer) => offer.zppCertified);

    dispatch(
      Actions.setOffers({
        zpp: zppPlan ? (zppPlan as unknown as SubscriptionOffer) : null,
        subscriptions: data.offers.filter((offer) => !offer.zppCertified) as (SinglePaymentOffer | SubscriptionOffer)[],
      }),
    );
  }, [data]);

  return {
    couponCode: enteredCouponCode,
    loading,
    error,
    refetch,
    offers: offers ?? [],
  };
};
